import {EstimateValues, NutritionEstimate} from "../interfaces";

export const fragmentsCount = (estimateValue: EstimateValues): number => {
  switch (estimateValue) {
    case EstimateValues.Low:
      return 1;
    case EstimateValues.Med:
      return 2;
    case EstimateValues.High:
      return 3;
    default:
      return 1;
  }
};

export const getNutritionTextDescription = (
  estimate: NutritionEstimate
): string => {
  const valueText =
    estimate.value === EstimateValues.Med ? "medium" : estimate.value;
  const isCalories = estimate.name === "Calories";
  const numberOrAmount = isCalories ? "number" : "amount";
  const estimateBracket = estimate.bracket.replace("-", " to ");

  const textFallback = `This dish contains a ${valueText} ${numberOrAmount} of ${
    estimate.name
  } (${estimateBracket} ${isCalories ? "" : "of"} ${estimate.name}).`;
  return textFallback;
};
